
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.625 3.542c.46 0 .833.373.833.833v3.75c0 .46-.373.833-.833.833h-3.75a.833.833 0 110-1.666h2.917V4.375c0-.46.373-.833.833-.833z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.7 4.079a6.042 6.042 0 102.947 10.315.833.833 0 011.144 1.212 7.708 7.708 0 11.147-11.07l3.25 2.974a.833.833 0 01-1.126 1.23L14.8 5.753A6.042 6.042 0 0011.7 4.078z","fill":"#282E3E"}})])
          )
        }
      }
    